import { HugeiconsIcon } from "@hugeicons/react"
import {
  Alert02Icon,
  Cancel01Icon,
  CheckmarkCircle03Icon,
} from "@hugeicons-pro/core-stroke-rounded"
import React from "react"
import { ExternalToast, toast as sonnerToast } from "sonner"

type ToastProps = {
  type?: "error" | "success"
  title: string
  description?: string
}

export function toast(toast: ToastProps, options?: ExternalToast) {
  return sonnerToast.custom(
    (id) => (
      <div className="shadow-component-bg font-inter bg-background-primary border-border-primary/30 relative flex w-75 gap-2 rounded-2xl border p-4 select-none">
        {toast.type === "error" && (
          <HugeiconsIcon
            icon={Alert02Icon}
            size={14}
            strokeWidth={2}
            className="text-text-error shrink-0"
          />
        )}

        {toast.type === "success" && (
          <HugeiconsIcon
            icon={CheckmarkCircle03Icon}
            size={14}
            strokeWidth={2}
            className="text-text-success shrink-0"
          />
        )}

        <div className="flex w-full flex-col gap-1">
          <h2 className="text-primary text-heading-small -mt-[3px] text-[13px]/5 font-semibold">
            {toast.title}
          </h2>

          {toast.description && (
            <p
              title={toast.description}
              className="text-secondary text-body-medium-regular -mb-0.5 line-clamp-3 text-[13px]/5 font-normal"
            >
              {toast.description}
            </p>
          )}
        </div>

        <button
          onClick={() => sonnerToast.dismiss(id)}
          className="text-text-secondary hover:bg-slate-5 hover:text-slate-11 absolute top-2 right-2 flex h-5 w-5 items-center justify-center rounded bg-transparent"
          aria-label="Close"
        >
          <HugeiconsIcon icon={Cancel01Icon} size={14} strokeWidth={2} />
        </button>
      </div>
    ),
    {
      ...(toast.type === "error" && { duration: 5000 }),
      ...options,
    },
  )
}

export function toastDismiss(id: string | undefined) {
  sonnerToast.dismiss(id)
}
